import { useEffect, useState } from "react";
import { _get, _put } from "../../../libraries/fetch";
import { copyToClipboard, showToast } from "../../../libraries/clipboardUtils";
import { getBranchURL, getHeartBeatByBranchURL } from "../../../libraries/apiUrl";
import { getLoggedInAdminUserId } from "../../../libraries/auth";
import QrCodes from "./Qr_Code";
import BranchProfileCards from "./BranchProfileCards";
import JSZip from "jszip";
import { Document, Packer, Paragraph, TextRun, HeadingLevel } from "docx";
import QRCode from "qrcode";

function resolveBranchFromResponse(data) {
  if (!data || typeof data !== "object") {
    return null;
  }
  if (data._id || data.id) {
    return data;
  }
  const nested = data.branch || data.response || data.data;
  if (nested && typeof nested === "object" && (nested._id || nested.id)) {
    return nested;
  }
  return null;
}

function buildBranchUpdatePayload(branch, modifiedBy) {
  const companyId =
    branch.company?._id ||
    branch.company?.id ||
    branch.company ||
    branch.companyId ||
    "";

  const payload = {
    name: branch.name,
    type: branch.type,
    address: branch.address,
    phone: branch.phone,
    whatsapp: branch.whatsapp,
    feeWhatsapp: branch.feeWhatsapp,
    visitorWhatsapp: branch.visitorWhatsapp,
    registrationWhatsapp: branch.registrationWhatsapp,
    fax: branch.fax,
    contactPerson: branch.contactPerson,
    contactPersonEmail: branch.contactPersonEmail,
    starttime: branch.starttime,
    endtime: branch.endtime,
    company: companyId,
    appPassword: branch.appPassword,
    modifiedBy: modifiedBy || branch.modifiedBy,
    domain: branch.domain,
    visitorFee: branch.visitorFee,
    lockDefaulterOnACT: branch.lockDefaulterOnACT
  };

  if (branch.generalTaxSettings) {
    payload.generalTaxSettings = {
      isTaxOnPayout: branch.generalTaxSettings.isTaxOnPayout,
      payoutTaxOnRate: branch.generalTaxSettings.payoutTaxOnRate
    };
  }

  if (Array.isArray(branch.visitorTypes)) {
    payload.visitorTypes = branch.visitorTypes.map((v) => ({
      name: v.name,
      fees: v.fees
    }));
  }

  if (Array.isArray(branch.payments)) {
    payload.payments = branch.payments.map((p) => ({
      name: p.name,
      accountTitle: p.accountTitle,
      accountNumber: p.accountNumber,
      logo: p.logo,
      type: p.type,
      taxSettings: p.taxSettings
        ? {
            taxRate: p.taxSettings.taxRate,
            taxCalculationType: p.taxSettings.taxCalculationType
          }
        : undefined
    }));
  }

  return payload;
}

function Info({ companyId, branchId, Name, licenseKey, phone, email, address, branch }) {
  const [registration, setRegistration] = useState("Loading....");

  const [visitor, setVisitor] = useState("Loading....");

  const [enquiry, setEnquiry] = useState("Loading....");

  const [generalQr, setGeneralQr] = useState("Loading....");

  const [branchName, setBranchName] = useState("Loading....");

  const [branchIdN, setBranchIdN] = useState("Loading....");

  const [companyIdN, setCompanyIdN] = useState("Loading....");

  const [heartBeatIdN, setHeartBeatIdN] = useState("Loading....");

  const [licenseKeyState, setLicenseKeyState] = useState("Loading....");

  const [phoneState, setPhoneState] = useState("Loading....");

  const [emailState, setEmailState] = useState("Loading....");

  const [addressState, setAddressState] = useState("Loading...");

  const [isUpdatingBranch, setIsUpdatingBranch] = useState(false);

  useEffect(() => {
    setRegistration("http://tecfolk.com/qr/redirect.html?type=registration&company=" + companyId + "&branch=" + branchId);
    setEnquiry("http://tecfolk.com/qr/redirect.html?type=enquiry&company=" + companyId + "&branch=" + branchId);
    setVisitor("http://tecfolk.com/qr/redirect.html?type=visitor&company=" + companyId + "&branch=" + branchId);
    setGeneralQr("https://www.instagram.com/theworkouts.2026/");
    setBranchName(Name);
    setBranchIdN(branchId);
    setCompanyIdN(companyId);
    getHeartBeat(branchId);
    // Set license key from props - handle both key and licenseKey field names
    setLicenseKeyState(licenseKey || "Not available");
    setPhoneState(phone || "Not available");
    setEmailState(email || "Not available");
    setAddressState(address || "Not available");
  }, [companyId, branchId, Name, licenseKey, phone, email, address]);

  function resolveHeartbeatIdFromResponse(data) {
    if (!data || typeof data !== "object") {
      return null;
    }

    if (data.success === false || data.status === false) {
      return null;
    }

    const candidates = [data.response, data.data, data];
    for (const candidate of candidates) {
      if (!candidate) {
        continue;
      }
      if (typeof candidate === "string" && candidate.trim()) {
        return candidate.trim();
      }
      if (typeof candidate !== "object" || Array.isArray(candidate)) {
        continue;
      }
      const id = candidate._id || candidate.id || candidate.heartbeatId;
      if (id) {
        return String(id);
      }
    }

    return null;
  }

  function getHeartBeat(branchId) {
    if (!branchId) {
      setHeartBeatIdN("Loading....");
      return;
    }

    setHeartBeatIdN("Loading....");
    _get(getHeartBeatByBranchURL(branchId), { useCache: false })
      .then((data) => {
        const heartbeatId = resolveHeartbeatIdFromResponse(data);
        setHeartBeatIdN(heartbeatId || "N/A");
      })
      .catch(() => {
        setHeartBeatIdN("N/A");
      });
  }

  const [copied, setCopied] = useState(false);

  const [contactCopied, setContactCopied] = useState(false);

  const [copiedUrl, setCopiedUrl] = useState(null);
  const [copiedConfigField, setCopiedConfigField] = useState(null);

  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadCompletePopup, setDownloadCompletePopup] = useState(false);

  async function handleCopyConfigField(value, fieldName) {
    const result = await copyToClipboard(value, { label: fieldName });
    if (result.success) {
      showToast('Copied!', 'success');
      setCopiedConfigField(fieldName);
      setTimeout(() => {
        setCopiedConfigField(null);
      }, 2000);
    } else {
      showToast(result.message, 'error');
    }
  }

  async function handleCopyAllConfig() {
    const infoText = `Branch Name: ${branchName}
Company Id: ${companyIdN}
Branch Id: ${branchIdN}
Heartbeat Id: ${heartBeatIdN}
License Key: ${licenseKeyState}`;

    const result = await copyToClipboard(infoText, { label: "Branch config" });
    if (result.success) {
      showToast('Config copied!', 'success');
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } else {
      showToast(result.message, 'error');
    }
  }

  async function handleCopyContactInfo() {
    const contactInfoText = `Number: ${phoneState}
Email: ${emailState}
Address: ${addressState}`;

    const result = await copyToClipboard(contactInfoText, { label: "Contact info" });
    if (result.success) {
      showToast('Contact info copied!', 'success');
      setContactCopied(true);
      setTimeout(() => {
        setContactCopied(false);
      }, 2000);
    } else {
      showToast(result.message, 'error');
    }
  }

  async function handleCopyUrl(url, urlName) {
    const result = await copyToClipboard(url, { label: urlName || "URL" });
    if (result.success) {
      showToast('URL copied!', 'success');
      setCopiedUrl(urlName);
      setTimeout(() => {
        setCopiedUrl(null);
      }, 2000);
    } else {
      showToast(result.message, 'error');
    }
  }

  async function handleDownload() {
    if (isDownloading || !registration || !enquiry || !visitor || !generalQr) return;
    setIsDownloading(true);
    setDownloadCompletePopup(false);
    try {
      const folderName = (branchName || "Branch").replace(/[^a-zA-Z0-9]/g, "_");
      const zip = new JSZip();

      const qrOptions = { type: "image/png", width: 200, margin: 1 };
      const [regPng, enqPng, visPng, genPng] = await Promise.all([
        QRCode.toDataURL(registration, qrOptions),
        QRCode.toDataURL(enquiry, qrOptions),
        QRCode.toDataURL(visitor, qrOptions),
        QRCode.toDataURL(generalQr, qrOptions)
      ]);

      zip.folder("Logo");
      zip.folder("PSD");
      zip.folder("Standees");

      const qrFolder = zip.folder("QR");
      qrFolder.file("Registration.png", regPng.split(",")[1], { base64: true });
      qrFolder.file("Enquiry.png", enqPng.split(",")[1], { base64: true });
      qrFolder.file("Visitor.png", visPng.split(",")[1], { base64: true });
      qrFolder.file("General.png", genPng.split(",")[1], { base64: true });

      const infoFolder = zip.folder("Info");

      const doc = new Document({
        sections: [{
          children: [
            new Paragraph({
              text: branchName || "Branch",
              heading: HeadingLevel.HEADING_1,
              spacing: { after: 400 }
            }),
            new Paragraph({
              text: "Contact Details",
              heading: HeadingLevel.HEADING_2,
              spacing: { before: 200, after: 200 }
            }),
            new Paragraph({
              children: [new TextRun({ text: "Phone: " + (phoneState || "N/A") })]
            }),
            new Paragraph({
              children: [new TextRun({ text: "Email: " + (emailState || "N/A") })]
            }),
            new Paragraph({
              children: [new TextRun({ text: "Address: " + (addressState || "N/A") })]
            }),
            new Paragraph({
              text: "QR Links",
              heading: HeadingLevel.HEADING_2,
              spacing: { before: 200, after: 400 }
            }),
            new Paragraph({
              children: [new TextRun({ text: "Registration: " + (registration || "N/A") })],
              spacing: { before: 200 }
            }),
            new Paragraph({
              children: [new TextRun({ text: "Enquiry: " + (enquiry || "N/A") })]
            }),
            new Paragraph({
              children: [new TextRun({ text: "Visitor: " + (visitor || "N/A") })]
            }),
            new Paragraph({
              children: [new TextRun({ text: "General: " + (generalQr || "N/A") })]
            })
          ]
        }]
      });

      const docBlob = await Packer.toBlob(doc);
      infoFolder.file("Branch_Info.docx", docBlob);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      const url = URL.createObjectURL(zipBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${folderName}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      setDownloadCompletePopup(true);
      setTimeout(() => setDownloadCompletePopup(false), 4000);
    } catch (err) {
      console.error("Download failed:", err);
    } finally {
      setIsDownloading(false);
    }
  }

  async function handleUpdateBranch() {
    const id = branchId || branchIdN;
    if (!id || isUpdatingBranch) {
      return;
    }

    const confirmed = window.confirm("Are you sure you want to Update Branch?");
    if (!confirmed) {
      return;
    }

    setIsUpdatingBranch(true);
    try {
      const branchResponse = await _get(getBranchURL(id), { useCache: false });
      const branch = resolveBranchFromResponse(branchResponse);
      if (!branch) {
        showToast("Could not load branch data", "error");
        return;
      }

      const payload = buildBranchUpdatePayload(branch, getLoggedInAdminUserId());
      const updateResponse = await _put(getBranchURL(branch._id || id), payload);
      const updatedBranch = resolveBranchFromResponse(updateResponse) || updateResponse?.branch;

      if (updatedBranch || updateResponse) {
        if (updatedBranch?.name) {
          setBranchName(updatedBranch.name);
        }
        if (updatedBranch?.phone) {
          setPhoneState(updatedBranch.phone);
        }
        if (updatedBranch?.contactPersonEmail || updatedBranch?.email) {
          setEmailState(updatedBranch.contactPersonEmail || updatedBranch.email);
        }
        if (updatedBranch?.address) {
          setAddressState(updatedBranch.address);
        }
        showToast("Branch Successfully Updated", "success");
      } else {
        showToast("Something Went Wrong", "error");
      }
    } catch (err) {
      console.error("Update branch failed:", err);
      showToast(err?.message || "Failed to update branch", "error");
    } finally {
      setIsUpdatingBranch(false);
    }
  }

  return (
    <>
      <style>{`
        @keyframes slideInBounce {
          0% {
            opacity: 0;
            transform: translateX(20px) scale(0.8);
          }
          50% {
            transform: translateX(-5px) scale(1.05);
          }
          100% {
            opacity: 1;
            transform: translateX(0) scale(1);
          }
        }
      `}</style>
      <div className="configMain">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 20px 0 20px',
          gap: '12px'
        }}>
          <button
            type="button"
            onClick={handleUpdateBranch}
            disabled={isUpdatingBranch}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '8px',
              border: '2px solid #187718',
              backgroundColor: isUpdatingBranch ? '#333' : '#187718',
              color: '#fff',
              cursor: isUpdatingBranch ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(24, 119, 24, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!isUpdatingBranch) {
                e.currentTarget.style.backgroundColor = '#20a020';
                e.currentTarget.style.transform = 'scale(1.02)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isUpdatingBranch) {
                e.currentTarget.style.backgroundColor = '#187718';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20h9"/>
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
            </svg>
            {isUpdatingBranch ? "Updating..." : "Update Branch"}
          </button>
          <button
            onClick={handleDownload}
            disabled={isDownloading}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              borderRadius: '8px',
              border: '2px solid #187718',
              backgroundColor: isDownloading ? '#333' : '#187718',
              color: '#fff',
              cursor: isDownloading ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(24, 119, 24, 0.3)'
            }}
            onMouseEnter={(e) => {
              if (!isDownloading) {
                e.currentTarget.style.backgroundColor = '#20a020';
                e.currentTarget.style.transform = 'scale(1.02)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isDownloading) {
                e.currentTarget.style.backgroundColor = '#187718';
                e.currentTarget.style.transform = 'scale(1)';
              }
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            {isDownloading ? "Preparing..." : "Download Folder"}
          </button>
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
          gap: '20px',
          padding: '20px'
        }}>
          {/* Registration Page Card */}
          <div
            className="user-card"
            onClick={() => handleCopyUrl(registration, 'registration')}
            style={{
              backgroundColor: '#2a2d35',
              border: '1px solid #444',
              borderRadius: '12px',
              padding: '24px',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#33363f';
              e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5), 0 0 20px rgba(24, 119, 24, 0.4)';
              e.currentTarget.style.border = '1px solid #187718';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2a2d35';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
              e.currentTarget.style.border = '1px solid #444';
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              <h3 style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#fff',
                margin: '0 0 0 0',
                borderBottom: '2px solid #187718',
                paddingBottom: '12px'
              }}>
                Registration Page Link
              </h3>
            </div>

            <div style={{ fontSize: '14px', color: '#fff', fontWeight: '500', wordBreak: 'break-all', lineHeight: '1.6', fontFamily: 'monospace' }}>
              {registration || "N/A"}
            </div>

            {copiedUrl === 'registration' && (
              <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                color: '#fff',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                zIndex: 1000,
                boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                animation: 'slideInBounce 0.4s ease-out',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                transform: 'scale(1)',
                letterSpacing: '0.3px'
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
                <span>Registration Page Link Copied!</span>
              </div>
            )}
          </div>

          {/* Enquiry Page Card */}
          <div
            className="user-card"
            onClick={() => handleCopyUrl(enquiry, 'enquiry')}
            style={{
              backgroundColor: '#2a2d35',
              border: '1px solid #444',
              borderRadius: '12px',
              padding: '24px',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#33363f';
              e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5), 0 0 20px rgba(24, 119, 24, 0.4)';
              e.currentTarget.style.border = '1px solid #187718';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2a2d35';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
              e.currentTarget.style.border = '1px solid #444';
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              <h3 style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#fff',
                margin: '0 0 0 0',
                borderBottom: '2px solid #187718',
                paddingBottom: '12px'
              }}>
                Enquiry Page Link
              </h3>
            </div>

            <div style={{ fontSize: '14px', color: '#fff', fontWeight: '500', wordBreak: 'break-all', lineHeight: '1.6', fontFamily: 'monospace' }}>
              {enquiry || "N/A"}
            </div>

            {copiedUrl === 'enquiry' && (
              <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                color: '#fff',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                zIndex: 1000,
                boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                animation: 'slideInBounce 0.4s ease-out',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                transform: 'scale(1)',
                letterSpacing: '0.3px'
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
                <span>Enquiry Page Link Copied!</span>
              </div>
            )}
          </div>

          {/* Visitor Page Card */}
          <div
            className="user-card"
            onClick={() => handleCopyUrl(visitor, 'visitor')}
            style={{
              backgroundColor: '#2a2d35',
              border: '1px solid #444',
              borderRadius: '12px',
              padding: '24px',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#33363f';
              e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5), 0 0 20px rgba(24, 119, 24, 0.4)';
              e.currentTarget.style.border = '1px solid #187718';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2a2d35';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
              e.currentTarget.style.border = '1px solid #444';
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              <h3 style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#fff',
                margin: '0 0 0 0',
                borderBottom: '2px solid #187718',
                paddingBottom: '12px'
              }}>
                Visitor Page Link
              </h3>
            </div>

            <div style={{ fontSize: '14px', color: '#fff', fontWeight: '500', wordBreak: 'break-all', lineHeight: '1.6', fontFamily: 'monospace' }}>
              {visitor || "N/A"}
            </div>

            {copiedUrl === 'visitor' && (
              <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                color: '#fff',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                zIndex: 1000,
                boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                animation: 'slideInBounce 0.4s ease-out',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                transform: 'scale(1)',
                letterSpacing: '0.3px'
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
                <span>Visitor Page Link Copied!</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="configMain">
        <div style={{
          display: 'flex',
          gap: '20px',
          padding: '20px',
          flexWrap: 'wrap'
        }}>
          {/* Configuration Card */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
            gap: '20px'
          }}>
            <div
              className="user-card"
              style={{
                backgroundColor: '#2a2d35',
                border: '1px solid #444',
                borderRadius: '12px',
                padding: '24px',
                transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                position: 'relative',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                overflow: 'hidden'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#33363f';
                e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5), 0 0 20px rgba(24, 119, 24, 0.4)';
                e.currentTarget.style.border = '1px solid #187718';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#2a2d35';
                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
                e.currentTarget.style.border = '1px solid #444';
              }}
            >
            <div style={{ marginBottom: '20px' }}>
              <h3
                onClick={handleCopyAllConfig}
                style={{
                  fontSize: '20px',
                  fontWeight: 'bold',
                  color: '#fff',
                  margin: '0 0 0 0',
                  borderBottom: '2px solid #187718',
                  paddingBottom: '12px',
                  cursor: 'pointer',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#4ade80';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#fff';
                }}
              >
                Configuration
              </h3>
            </div>

            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
              <span style={{ fontSize: '15px', color: '#888', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="14" height="14" fill="currentColor">
                  <path d="M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16z"/>
                </svg>
                Branch Name
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}>
                <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', textAlign: 'right' }}>
                  {branchName || "N/A"}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyConfigField(branchName || "N/A", 'branchName');
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.2s ease',
                    color: copiedConfigField === 'branchName' ? '#4ade80' : '#888'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.color = '#4ade80';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.color = copiedConfigField === 'branchName' ? '#4ade80' : '#888';
                  }}
                >
                  {copiedConfigField === 'branchName' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z" />
                    </svg>
                  )}
                </button>
                {copiedConfigField === 'branchName' && (
                  <div style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                    color: '#fff',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    animation: 'slideInBounce 0.4s ease-out',
                    border: '1px solid rgba(255,255,255,0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    <span>Branch Name Copied!</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
              <span style={{ fontSize: '15px', color: '#888', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="14" height="14" fill="currentColor">
                  <path d="M323.4 85.2c-11.8 5.2-22.7 12.8-31.8 21.8l-58.4 58.4C199.3 191.1 192 212.1 192 234.7V320H144c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h192 192c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H448V234.7c0-22.6-7.3-43.6-20.8-60.5l-58.4-58.4c-9.1-9.1-20-16.6-31.8-21.8C323.2 84.7 320 84 320 84s-3.2 .7-3.4 1.2zM64 128h96v64H64V128zm0 256H32c-17.7 0-32-14.3-32-32V352H64v32zm544-32v32h32c0-17.7-14.3-32-32-32zm-32-128v64h32V224H576z"/>
                </svg>
                Company Id
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}>
                <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', textAlign: 'right' }}>
                  {companyIdN || "N/A"}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyConfigField(companyIdN || "N/A", 'companyId');
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.2s ease',
                    color: copiedConfigField === 'companyId' ? '#4ade80' : '#888'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.color = '#4ade80';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.color = copiedConfigField === 'companyId' ? '#4ade80' : '#888';
                  }}
                >
                  {copiedConfigField === 'companyId' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z" />
                    </svg>
                  )}
                </button>
                {copiedConfigField === 'companyId' && (
                  <div style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                    color: '#fff',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    animation: 'slideInBounce 0.4s ease-out',
                    border: '1px solid rgba(255,255,255,0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    <span>Company Id Copied!</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
              <span style={{ fontSize: '15px', color: '#888', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
                  <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"/>
                </svg>
                Branch Id
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}>
                <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', textAlign: 'right' }}>
                  {branchIdN || "N/A"}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyConfigField(branchIdN || "N/A", 'branchId');
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.2s ease',
                    color: copiedConfigField === 'branchId' ? '#4ade80' : '#888'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.color = '#4ade80';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.color = copiedConfigField === 'branchId' ? '#4ade80' : '#888';
                  }}
                >
                  {copiedConfigField === 'branchId' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z" />
                    </svg>
                  )}
                </button>
                {copiedConfigField === 'branchId' && (
                  <div style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                    color: '#fff',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    animation: 'slideInBounce 0.4s ease-out',
                    border: '1px solid rgba(255,255,255,0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    <span>Branch Id Copied!</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
              <span style={{ fontSize: '15px', color: '#888', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="currentColor">
                  <path d="M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320.9 190 336.6 224c7 14.6 21.3 24 37.4 24H478.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.6 83.2c-1.4 2.9-4.2 4.9-7.4 4.9H126.1l-14.5-28.8c-1.5-3-4.2-5.1-7.4-5.1H8.3c-5 0-9.3 3.7-9.9 8.7s2.5 9.8 7.3 12.3L165.7 330l30.6 75.2c4.5 11.1 15 18.1 26.9 18.1s22.4-7 26.9-18.1l41.5-99.9c1.5-3.6 4.7-6.3 8.5-6.9l131-21.4c5.6-.9 9.5-5.9 8.6-11.5s-5.9-9.5-11.5-8.6z"/>
                </svg>
                Heartbeat Id
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}>
                <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', textAlign: 'right' }}>
                  {heartBeatIdN || "N/A"}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyConfigField(heartBeatIdN || "N/A", 'heartbeatId');
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.2s ease',
                    color: copiedConfigField === 'heartbeatId' ? '#4ade80' : '#888'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.color = '#4ade80';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.color = copiedConfigField === 'heartbeatId' ? '#4ade80' : '#888';
                  }}
                >
                  {copiedConfigField === 'heartbeatId' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z" />
                    </svg>
                  )}
                </button>
                {copiedConfigField === 'heartbeatId' && (
                  <div style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                    color: '#fff',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    animation: 'slideInBounce 0.4s ease-out',
                    border: '1px solid rgba(255,255,255,0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    <span>Heartbeat Id Copied!</span>
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: '0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
              <span style={{ fontSize: '15px', color: '#888', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="currentColor">
                  <path d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"/>
                </svg>
                License Key
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', position: 'relative' }}>
                <span style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', textAlign: 'right', fontFamily: 'monospace' }}>
                  {licenseKeyState || "N/A"}
                </span>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCopyConfigField(licenseKeyState || "N/A", 'licenseKey');
                  }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'transform 0.2s ease',
                    color: copiedConfigField === 'licenseKey' ? '#4ade80' : '#888'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.color = '#4ade80';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.color = copiedConfigField === 'licenseKey' ? '#4ade80' : '#888';
                  }}
                >
                  {copiedConfigField === 'licenseKey' ? (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16" fill="currentColor">
                      <path d="M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z" />
                    </svg>
                  )}
                </button>
                {copiedConfigField === 'licenseKey' && (
                  <div style={{
                    position: 'absolute',
                    top: '-40px',
                    right: '0',
                    background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                    color: '#fff',
                    padding: '6px 12px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    animation: 'slideInBounce 0.4s ease-out',
                    border: '1px solid rgba(255,255,255,0.2)',
                    whiteSpace: 'nowrap'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="14" height="14" fill="currentColor">
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                    </svg>
                    <span>License Key Copied!</span>
                  </div>
                )}
              </div>
            </div>

            {copied && (
              <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                color: '#fff',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                zIndex: 1000,
                boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                animation: 'slideInBounce 0.4s ease-out',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                transform: 'scale(1)',
                letterSpacing: '0.3px'
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
                <span>Configuration Copied!</span>
              </div>
            )}

          </div>
        </div>

          {/* Contact Details Card */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))',
            gap: '20px'
          }}>
            <div
              className="user-card"
              onClick={handleCopyContactInfo}
            style={{
              backgroundColor: '#2a2d35',
              border: '1px solid #444',
              borderRadius: '12px',
              padding: '24px',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#33363f';
              e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.5), 0 0 20px rgba(24, 119, 24, 0.4)';
              e.currentTarget.style.border = '1px solid #187718';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#2a2d35';
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
              e.currentTarget.style.border = '1px solid #444';
            }}
          >
            <div style={{ marginBottom: '20px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#fff',
                margin: '0 0 0 0',
                borderBottom: '2px solid #187718',
                paddingBottom: '12px'
              }}>
                Contact Details
              </h3>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '13px', color: '#888', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="currentColor">
                  <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/>
                </svg>
                Phone Number
              </div>
              <div style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', lineHeight: '1.5' }}>
                {phoneState || "N/A"}
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '13px', color: '#888', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="14" height="14" fill="currentColor">
                  <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"/>
                </svg>
                Email Address
              </div>
              <div style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', lineHeight: '1.5' }}>
                {emailState || "N/A"}
              </div>
            </div>

            <div style={{ marginBottom: '0' }}>
              <div style={{ fontSize: '13px', color: '#888', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="14" height="14" fill="currentColor">
                  <path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/>
                </svg>
                Address
              </div>
              <div style={{ fontSize: '16px', color: '#fff', fontWeight: '600', wordBreak: 'break-word', lineHeight: '1.6' }}>
                {addressState || "N/A"}
              </div>
            </div>

            {contactCopied && (
              <div style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'linear-gradient(135deg, #187718 0%, #20a020 100%)',
                color: '#fff',
                padding: '10px 16px',
                borderRadius: '8px',
                fontSize: '13px',
                fontWeight: '600',
                zIndex: 1000,
                boxShadow: '0 4px 12px rgba(24, 119, 24, 0.4), 0 2px 4px rgba(0,0,0,0.2)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                animation: 'slideInBounce 0.4s ease-out',
                border: '1px solid rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                transform: 'scale(1)',
                letterSpacing: '0.3px'
              }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  width="16"
                  height="16"
                  fill="currentColor"
                  style={{ flexShrink: 0 }}
                >
                  <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                </svg>
                <span>Contact Details Copied!</span>
              </div>
            )}
          </div>
        </div>

          {/* QR Codes Cards */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 260px), 1fr))',
            gap: '20px',
            flex: '1',
            minWidth: 0
          }}>
            <QrCodes heading="Registration" url={registration} />
            <QrCodes heading="Enquiry" url={enquiry} />
            <QrCodes heading="Visitor" url={visitor} />
            <QrCodes heading="General" url={generalQr} />
          </div>

          <BranchProfileCards branch={branch} />
        </div>
        <br />
        <br />
        <br />
      </div>

      {downloadCompletePopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#2a2d35',
            border: '2px solid #187718',
            borderRadius: '12px',
            padding: '28px 36px',
            maxWidth: '420px',
            textAlign: 'center',
            boxShadow: '0 12px 40px rgba(0,0,0,0.4), 0 0 24px rgba(24, 119, 24, 0.3)',
            animation: 'slideInBounce 0.4s ease-out'
          }}>
            <div style={{
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              backgroundColor: 'rgba(24, 119, 24, 0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="28" height="28" fill="#4ade80">
                <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
              </svg>
            </div>
            <h3 style={{ margin: '0 0 8px', fontSize: '20px', color: '#fff', fontWeight: 'bold' }}>
              Download complete
            </h3>
            <p style={{ margin: 0, fontSize: '15px', color: '#aaa', lineHeight: 1.5 }}>
              Check downloads in your system.
            </p>
          </div>
        </div>
      )}

    </>
  );
}

export default Info;